export class ContentItemSearchItem implements IContentItemSearchItem {
    id?: string;
    contentItemTypeId?: string | undefined;
    platformId?: string | undefined;
    title?: string | undefined;
    dateCreated?: Date;
    dateUpdated?: Date;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    thumbFileId?: string | undefined;
    fileId?: string | undefined;
    metadataFileId?: string | undefined;
    contentItemCategoryId?: string | undefined;
    notes?: string | undefined;
    isAllAccounts?: boolean;
    isDisabled?: boolean;
    dateDisabled?: Date | undefined;
    accounts?: string[] | undefined;

    constructor(data?: IContentItemSearchItem) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contentItemTypeId = _data["contentItemTypeId"];
            this.platformId = _data["platformId"];
            this.title = _data["title"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : <any>undefined;
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.thumbFileId = _data["thumbFileId"];
            this.fileId = _data["fileId"];
            this.metadataFileId = _data["metadataFileId"];
            this.contentItemCategoryId = _data["contentItemCategoryId"];
            this.notes = _data["notes"];
            this.isAllAccounts = _data["isAllAccounts"];
            this.isDisabled = _data["isDisabled"];
            this.dateDisabled = _data["dateDisabled"] ? new Date(_data["dateDisabled"].toString()) : <any>undefined;
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (const item of _data["accounts"])
                    this.accounts!.push(item);
            }
        }
    }

    static fromJS(data: any): ContentItemSearchItem {
        data = typeof data === 'object' ? data : {};
        const result = new ContentItemSearchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contentItemTypeId"] = this.contentItemTypeId;
        data["platformId"] = this.platformId;
        data["title"] = this.title;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["thumbFileId"] = this.thumbFileId;
        data["fileId"] = this.fileId;
        data["metadataFileId"] = this.metadataFileId;
        data["contentItemCategoryId"] = this.contentItemCategoryId;
        data["notes"] = this.notes;
        data["isAllAccounts"] = this.isAllAccounts;
        data["isDisabled"] = this.isDisabled;
        data["dateDisabled"] = this.dateDisabled ? this.dateDisabled.toISOString() : <any>undefined;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (const item of this.accounts)
                data["accounts"].push(item);
        }
        return data;
    }
}

export interface IContentItemSearchItem {
    id?: string;
    contentItemTypeId?: string | undefined;
    platformId?: string | undefined;
    title?: string | undefined;
    dateCreated?: Date;
    dateUpdated?: Date;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    thumbFileId?: string | undefined;
    fileId?: string | undefined;
    metadataFileId?: string | undefined;
    contentItemCategoryId?: string | undefined;
    notes?: string | undefined;
    isAllAccounts?: boolean;
    isDisabled?: boolean;
    dateDisabled?: Date | undefined;
    accounts?: string[] | undefined;
}